/**
 * API base URL for ncareApi (/v1).
 *
 * Vue CLI replaces process.env.VUE_APP_* at build time. S3 (and similar static
 * hosts) cannot set env at runtime — run `npm run build` with the correct
 * `.env.production` (or rely on the default below), then upload `dist/`.
 */
const DEFAULT_API_BASE_URL = 'https://api.ncareclub.com/v1';

export default process.env.VUE_APP_API_BASE_URL || DEFAULT_API_BASE_URL;
